import { render, staticRenderFns } from "./AgbPage.vue?vue&type=template&id=6ecb6cb0&scoped=true&"
import script from "./AgbPage.vue?vue&type=script&lang=js&"
export * from "./AgbPage.vue?vue&type=script&lang=js&"
import style0 from "./AgbPage.vue?vue&type=style&index=0&id=6ecb6cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb6cb0",
  null
  
)

export default component.exports